import {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'
import ComingSoon from "../../../../partials/ComingSoon.tsx";

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  soon?: boolean;
  badge?: number;
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  soon,
  badge,
}) => {
  const {pathname} = useLocation()
  // console.log(pathname, to);
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {app} = config

  return (
    <div className='menu-item'>
      <Link className={clsx('menu-link without-sub', {active: isActive})} to={soon ? '#' : to}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}

        {icon && (
          <span className='menu-icon'>
            {' '}
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}

        {fontIcon && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}

        <span className='menu-title d-flex justify-content-between align-items-center'>
          {title}
          {soon && <ComingSoon className={'ms-2 float-end'} />}
          {!!badge && badge > 0 && (
            <span className='badge badge-sm badge-circle badge-light-danger ms-2'>{badge}</span>
          )}
        </span>
      </Link>
      {children}
    </div>
  )
}

export {SidebarMenuItem}
